<template>
  <v-form>
    <v-container v-if="loading">
      <div class="text-xs-center">
        <v-progress-circular indeterminate :size="150" :width="8" color="green"></v-progress-circular>
      </div>
    </v-container>
    <v-container v-else>
      <div style="height: 10px;"></div>
      <v-layout row wrap>
        <v-flex xs12>
          <v-text-field
            label="商品データファイル"
            @click="pickFile"
            v-model="fileName"
            prepend-icon="attach_file"
            hint="CSVファイル"
            v-validate="'required'"
            data-vv-name="userId"
            :error-messages="errors.collect('itemId')"
          ></v-text-field>
          <input
            type="file"
            ref="file"
            style="display: none"
            accept=".csv, .xls"
            @change="onFileChange($event)"
          />
          
          <v-btn block color="success" dark :loading="loading1" @click="fileUpload()">
            <v-icon dark left>cloud_upload</v-icon>アップロード実行
          </v-btn>
        </v-flex>

        <v-flex xs12 sm6>
          <v-select
            v-model="selectCategory"
            :items="itemCategories"
            label="商品カテゴリ"
            item-text="itemCategoryName"
            item-value="itemCategoryId"
            :sort-by="['itemCategoryId']"
            :sort-desc="[false]"
            return-object
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs6 sm6>
          <v-switch label="廃番商品も表示する" color="info" value="info" hide-details v-model="dispDeleted"></v-switch>
        </v-flex>
      </v-layout>
      <div style="height: 20px;"></div>

      <v-data-table
        :headers="headers"
        :items="items"
        class="elevation-1"
        hide-actions
        :customFilter="customFilter"
        :search="selectCategory"
        :custom-sort="customSort"
      >
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">{{ props.header.text }}</span>
            </template>
            <span>{{ props.header.text }}</span>
          </v-tooltip>
        </template>
        <template v-slot:items="props">
          <tr 
            v-if="dispDeleted === 'info' || (dispDeleted !== 'info' && '0' === props.item.isDeleted) || '1' === props.item.displayOnScreen "
            v-bind:class="{
              'deleted-class-name': props.item.isDeleted == '1' ? true : false,
              'invisible-class-name': props.item.displayOnScreen == '1' ? true : false,
              'changed-class-name': props.item.isChanged
            }"
          >
            <td class="text-xs-left" @click="forwardItemEdit(props.item)">{{ props.item.itemCategoryName }}</td>
            <td class="text-xs-left" @click="forwardItemEdit(props.item)">{{ props.item.itemName }}</td>
            <td class="text-xs-left" @click="forwardItemEdit(props.item)">{{ props.item.janCode }}</td>
            <td class="text-xs-right" @click="forwardItemEdit(props.item)">{{ Number(props.item.unitPrice || 0).toLocaleString() }}</td>
            <td class="text-xs-right">
              <input
                type="number"
                categoryName="numberOfStocks[]"
                v-model="props.item.numberOfStocks"
                min="0"
                class="column-input"
                style="width: 100% !important;"
                @change="onChangeStock(props.item)"
              />
            </td>
            <td class="text-xs-right">
              <input
                type="number"
                categoryName="numberOfStocks[]"
                v-model="props.item.orderLimitNumber"
                min="0"
                class="column-input"
                style="width: 100% !important;"
                @change="onChangeOrderLimit(props.item)"
              />
            </td>
          </tr>
        </template>
      </v-data-table>
      <br />

      <!-- 버튼 영역 -->
      <div class="footer-btns">
        <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-admin-menu' }">
          <v-icon color="black" left>home</v-icon>Home
        </v-btn>
        <v-btn block color="primary" dark @click="downloadItemsCsv()">
          <v-icon dark left>get_app</v-icon>データダウンロード
        </v-btn>
        <v-btn block class="ma-2" :loading="loading2" :disabled="loading2" color="error" @click="updateItems()">
          <v-icon dark left>save</v-icon>データ一括更新
        </v-btn>
        <v-btn block color="success" dark :to="{ name: 'admin/new-item-regist', params: { category: 'dummy' }}">
          <v-icon dark left>create</v-icon>新規登録
        </v-btn>
      </div>
    </v-container>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'
import ServerApiCallService from '@/services/ServerApiCallService.js'
import axios from 'axios'
export default {
  created() {
    console.log('created')

    this.getAllItems()
  },
  methods: {
    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        if (a.itemCategoryId < b.itemCategoryId) {
          return -1
        } else if (a.itemCategoryId > b.itemCategoryId) {
          return 1
        }
        if (a.itemName < b.itemName) {
          return -1
        } else if (a.itemName > b.itemName) {
          return 1
        }
        return 0
      })
      return items
    },
    onChangeStock(changedItem) {
      console.log('change stock')
      changedItem.isChanged = true
    },
    onChangeOrderLimit(changedItem) {
      console.log('change order limit')
      changedItem.isChanged = true
    },
    updateItems() {
      console.log('update item dialog')
      let thisObj = this
      thisObj.loading2 = true

      let filteringItems = this.items.filter(function(value) {
        if (value.isChanged == true) {
          return true
        } else {
          return false
        }
      })

      if (filteringItems.length === 0) {
        this.$parent.$parent.$parent.showErrorDialog(
          '一括更新対象の商品が選択されていません'
        )
        thisObj.loading2 = false
        return
      }

      ServerApiCallService.itemsUpdateStock(filteringItems)
        .then(() => {
          console.log('completed stock update ')
          thisObj.loading2 = false
          // 変更フラグの初期化
          thisObj.items.forEach(item => {
            item.isChanged = false
          })
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    async getAllItems() {
      console.log('refresh items')
      let thisObj = this
      thisObj.loading = true      

      ServerApiCallService.itemCategories()
        .then(response => {

          // 무효(status=0)로 된 카테고리는 제외한다
          let tmpCategories = [];
          for (let i=0; i<response.data.itemCategories.length; i++) {
            if (response.data.itemCategories[i].status === '1') {
              tmpCategories.push(response.data.itemCategories[i]);
            }
          }
          thisObj.itemCategories = tmpCategories;
          thisObj.itemCategories.unshift({
            itemCategoryId: '#',
            itemCategoryName: '全て'
          })
          // 初期表示時の
          thisObj.loading = false
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })

      ServerApiCallService.items()
        .then(response => {
          thisObj.items = response.data.items
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    customFilter(items, search) {
      if (search.itemCategoryName === '全て') {
        return items
      } else {
        let filteringItems = items.filter(function(value) {
          if (value.itemCategoryId === search.itemCategoryId) {
            return true
          } else {
            return false
          }
        })

        return filteringItems
      }
    },    
    forwardItemEdit(itemInfo) {
      this.$router.push({
        name: 'admin_items_update',
        params: { itemCode: itemInfo.itemCode }
        // params: { itemInfo: itemInfo, category: this.category }
      })
    },


    // add kium 20240131 start
    pickFile() {
      this.$refs.file.click()
    },
    onFileChange(e) {
      // const files = e.target.files
      this.targetFile = e.target.files[0]

      if (this.targetFile !== undefined) {
        this.fileName = this.targetFile.name
      }
    },
    async fileUpload() {
      const valid = await this.$validator.validateAll()

      if (!valid) {
        this.$parent.$parent.$parent.showErrorDialog(
          this.$t('hasInputError')
        )
        return
      }

      const formData = new FormData()
      formData.append('uploadFile', this.targetFile)
      formData.append('charsetName', this.fileFormat)

      const sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent
      }

      this.loading1 = true

      try {
        await ServerApiCallService.sendItemsFile(formData, sendContext)
        await this.getAllItems()

      } catch (error) {
        console.error('商品CSVアップロード失敗', error)
      } finally {
        this.loading1 = false
      }
    },
    downloadItemsCsv() {
      axios
        .create({
          baseURL: ServerApiCallService.getServerUrl(),
          withCredentials: false, // This is the default
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json;charset=utf-8',
            accessToken: window.localStorage.getItem('accessToken')
          }
        })
        .get('/admin/items-download', {
          responseType: 'blob'
        })
        .then(({ data }) => {
          let blob = new Blob([data], { type: 'text/csv' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = '商品一覧.csv'
          link.click()
        })
    }
  },
  computed: {
    ...mapState({
      user: state => state.admin
    }),
    selectCategory: {
      get() {
        return this.$store.state.adminSession.selectCategory
      },
      set(value) {
        this.$store.commit('SET_SELECTED_ITEM_CATEGORY', value)
      }
    }
  },
  data() {
    return {
      loader: null,
      loading: true,
      loading1: false,
      loading2: false,
      dispDeleted: 'info',
      items: [],
      itemCategories: [],

      targetFile: null,
      fileName: '',
      fileFormat: 'SHIFT-JIS',

      headers: [
        {
          text: 'カテゴリ',
          align: 'left',
          value: 'itemCategoryName',
          width: '150px',
          sortable: false
        },
        {
          text: '商品名',
          align: 'left',
          value: 'itemName',
          width: '150px',
          sortable: false
        },
        {
          text: 'JANコード',
          align: 'left',
          value: 'janCode',
          width: '30px',
          sortable: false
        },
        {
          text: '単価',
          align: 'center',
          value: 'unitPrice',
          width: '30px',
          sortable: false
        },
        {
          text: '在庫数',
          align: 'center',
          value: 'numberOfStocks',
          width: '100px',
          sortable: false
        },
        {
          text: '発注制限数',
          align: 'center',
          value: 'orderLimitNumber',
          width: '100px',
          sortable: false
        }
      ]
    }
  }
}
</script>

<style>
.column-input {
  width: 100% !important;
  height: 30px;
  text-align: right;
  border: 1px solid #c7c7c7;
  padding: 0 4px;
}

.deleted-class-name {
  background-color: #b3b3b3;
}
tr.changed-class-name,
.theme--light.v-table
  tbody
  tr.changed-class-name:hover:not(.v-datatable__expand-row) {
  background-color: #ffcccc;
}
.invisible-class-name {
  background-color: #b3e460;
}
.footer-btns {
  position: sticky;         /* 스크롤해도 하단 고정 */
  bottom: 0;                /* 컨테이너의 맨 아래 */
  display: flex;
  justify-content: space-between; /* 버튼 사이 일정 간격 */
  gap: 8px;                 /* 버튼들 사이 여백 */
  width: 100%;              /* 테이블 폭과 동일 */
  background: white;        /* 버튼 뒤 배경 */
  padding: 10px 0;          /* 위아래 여백 */
  z-index: 1000;
}
.footer-btns .v-btn {
  flex: 1;                  /* 버튼들이 같은 폭 */
}
</style>
